export default () => ({
  answers: [],
  questionnaire: {},
  currentQuestionIndex: 0,
  user: {},
  lang: ''
})
